(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("[data-slideshow] .slideshow-container");
  const dots = document.querySelectorAll("[data-slideshow] .dot");
  let index = 0;
  const totalSlides = dots.length;

  function showSlide(i) {
    index = i;
    container.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[index]) dots[index].classList.add("active");
  }

  function autoSlide() {
    index = (index + 1) % totalSlides;
    showSlide(index);
  }

  let slideInterval = setInterval(autoSlide, 5000); // 5 seconds

  dots.forEach(dot => {
    dot.addEventListener("click", function () {
      clearInterval(slideInterval);
      showSlide(parseInt(this.dataset.slideIndex));
      slideInterval = setInterval(autoSlide, 5000);
    });
  });

  if (totalSlides > 0) {
    showSlide(0); // Initial display
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
